import React, { useEffect, useState } from 'react';
import { publisherDispatchAPI, apiBaseUrl } from '../../utils/api';
import DataTable from '../../components_shared/DataTable';

export default function PublisherDispatchNotesPage(){
  const [rows,setRows]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState(null);

  useEffect(()=>{
    publisherDispatchAPI.list()
      .then(r=>setRows(r.data||[]))
      .catch(e=>setError(e.response?.data?.message||e.message))
      .finally(()=>setLoading(false));
  },[]);

  if(loading) return <p>Loading...</p>;
  if(error) return <div className="alert alert-danger">{error}</div>;

  const cols=[
    {accessorKey:'referenceNo',header:'Ref #'},
    {accessorKey:'workOrderNo',header:'Work Order'},
    {accessorKey:'totalQuantity',header:'Disp Qty',cell:({row})=>row.original.totalQuantity??row.original.quantity},
    {accessorKey:'balanceQtySum',header:'Bal Qty'},
    {accessorKey:'createdAt',header:'Date'},
    {id:'pdf',header:'PDF',cell:({row})=>(<button className="eduss-global-action-btn view" onClick={()=>window.open(`${apiBaseUrl}/api/v1/inventory/dispatch-notes/${row.original.id}/pdf`,'_blank')}>📄</button>)},
    {accessorKey:'status',header:'Status',cell:({row})=>(<span className="badge bg-secondary">{row.original.status}</span>)},
  ];

  return (
    <div className="container mt-3">
      <h2>My Dispatch Notes</h2>

      <DataTable data={rows} columns={cols} />

    </div>
  );
}
